export const cards = [
  {
    id: '01',
    title: 'Simulação',
    description: 'Faça uma simulação com o valor de empréstimo desejado. Essa etapa leva só 3 minutos!'
  },
  {
    id: '02',
    title: 'Avaliação',
    description: `O seu perfil e o do seu imóvel são analisados de maneira segura e rápida. Aqui, 
    conseguimos oferecer a melhor solução para você.`
  },
  {
    id: '03',
    title: 'Assinatura',
    description: `Depois do crédito aprovado, providenciamos os documentos e os emitimos para a sua 
    assinatura.`
  },
  {
    id: '04',
    title: 'Dinheiro liberado',
    description: 'Com tudo certo, é hora de assinar o contrato e receber o seu dinheiro!'
  }
]
